import { Component, OnInit } from '@angular/core';
import * as jQuery from 'jquery';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { UniqueReachAndFrequencyComponent } from '../unique-reach-and-frequency/unique-reach-and-frequency.component';

@Component({
	selector: 'app-unique-reach-and-frequency-r3',
	templateUrl: './unique-reach-and-frequency-r3.component.html',
	styleUrls: ['./unique-reach-and-frequency-r3.component.css']
})
export class UniqueReachAndFrequencyR3Component extends UniqueReachAndFrequencyComponent implements OnInit {
	public toolTipFormatter = {
		formatter(): any {
			if (this.series.name.includes('Uniques')) {
				return `<div class="toolTipClass"">
									<table >
										<tr class="tooltipRow"><td class="tooltipDate tooltipRow">
											<span>${this.x}</span></td></tr>
										<tr><td class="tooltipRow"><span style="color:${
											this.color
										};"class="tooltipDot">●</span><b>${this.point.y.toLocaleString()} </b><span>${
											this.series.name.trim().split(' ')[0]
				}</span></td></tr>
									</table>
								</div>`;
			} else {
				return `<div class="toolTipClass">
									<table>
										<tr class="tooltipRow"><td class="tooltipDate tooltipRow">
											<span>${this.x}</span></td></tr>
										<tr><td class="tooltipRow"> <span style="color:${this.color};" class="tooltipDot">●</span>
										<b>${this.point.y.toLocaleString()}x </b>
										<span>${this.series.name.trim().split(' ')[0]}</span></td></tr>
									</table>
								</div>`;
			}
		}
	};

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	ngOnInit(): void {
		super.ngOnInit();
	}

	scrollGraph(i): void {
		if (i < 0) {
			i = this.campaignsList.length - 1;
		} else if (i >= this.campaignsList.length) {
			i = 0;
		}
		jQuery('.rightCharts').animate(
			{
				scrollTop: jQuery('.rightCharts').scrollTop() + jQuery('#graph_' + i).position().top
			},
			100
		);
	}
}
